<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#2D3436" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div
          class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
        >
          {{ title }}
        </div>
        <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
          <!-- <v-alert prominent type="warning">
            El sector se encuentra cerrado por receso de verano. Podrás solicitar tus trámites desde el día 02/02
          </v-alert> -->
          <v-alert prominent type="info">
            IMPORTANTE! Los Trámites con Asterisco (*) tienen costo.
          </v-alert>
        </v-col>

        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Curso</label>
            <v-select
              v-model="curso"
              :items="cursos"
              item-text="text"
              item-value="value"
              label="Selecciona un curso"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Trámite</label>
            <v-select
              v-model="tramite"
              :items="tramites"
              item-text="text"
              item-value="value"
              label="Selecciona el trámite"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          <!--
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Sede del trámite</label>
            <v-select
              v-model="sede"
              :items="sedes"
              item-text="text"
              item-value="value"
              label="Selecciona la sede"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          -->
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>¿A quién va dirigido?</label>
            <v-text-field
              v-model="person"
              :rules="personRules"
              :counter="10"
              label="Escriba únicamente el nombre de la institución o empresa. Si coloca otra cosa su constancia será cancelada"
              required
            ></v-text-field>
          </v-col>

          <!-- Campos adicionales para trámite ID 36 -->
          <template v-if="tramite && tramite.value === 36">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Materias</label>
              <v-text-field
                v-model="materias"
                label="Ingrese las materias"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Tipo de Examen</label>
              <v-select
                v-model="tipoExamen"
                :items="tiposExamen"
                item-text="text"
                item-value="value"
                label="Seleccione el tipo de examen"
                required
              ></v-select>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Fecha del Examen</label>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="fechaExamen"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaExamen"
                    label="Seleccione la fecha"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fechaExamen" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(fechaExamen)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </template>

          <!--
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Urgencia</label>
            <v-select
              v-model="urgencia"
              :items="urgencias"
              item-text="text"
              item-value="value"
              label="Selecciona la urgencia"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          -->
        </v-row>

        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-btn
              color="success"
              elevation="7"
              large
              @click="addTramite()"
              v-on:click="examen = true"
              >Guardar</v-btn
            >
          </v-col>
        </v-row>
        <div>
          <br />
          <h2>
            Mis trámites
          </h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Urgencia
                  </th>
                  <th class="text-left">
                    Estado
                  </th>
                  <th class="text-left">
                    Trámite
                  </th>
                  <th>
                    Url
                  </th>
                  <th>
                    Fecha Solicitud
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(tramiteUserData, tramitesUserKey) in tramitesUser"
                  :key="tramitesUserKey"
                >
                  <td>{{ tramiteUserData.Urgencia }}</td>
                  <td>
                    <div
                      v-if="
                        tramiteUserData.Estado == 'Cancelado' &&
                          tramiteUserData.motivo != null
                      "
                    >
                      <v-btn
                        color="primary"
                        dark
                        @click="motivoRechazoTramite(tramiteUserData.motivo)"
                      >
                        Motivo del Rechazo
                      </v-btn>
                    </div>
                    <div v-else>
                      {{ tramiteUserData.Estado }}
                    </div>
                  </td>
                  <td>
                    {{
                      tramiteUserData.tramite
                        ? tramiteUserData.tramite.nombre
                        : ""
                    }}
                  </td>
                  <td>
                    <div
                      v-if="
                        tramitesEmail.includes(tramiteUserData.tramite.IDF) &&
                          tramiteUserData.Estado == 'Finalizado'
                      "
                    >
                      <v-alert
                        color="error"
                        style="
                                        color: white;
                                        padding: 5px 0px;
                                        margin-bottom: 5px !important;
                                        margin-top: 5px !important;
                                        display: inline-block;
                                        padding-left: 24px;
                                        padding-right: 25px;
                                      "
                      >
                        Este trámite sera enviado por correo electrónico
                      </v-alert>
                    </div>

                    <div v-else>
                      <div
                        v-if="
                          tramiteUserData.url &&
                            hoy >= tramiteUserData.dias_expiracion
                        "
                      >
                        <a
                          :href="tramiteUserData.url"
                          class="btn btn-success"
                          target="_blank"
                          >ver constancia</a
                        >
                      </div>
                    </div>
                  </td>
                  <td>{{ tramiteUserData.FechaRegistro }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>

      <v-dialog v-model="motivoRechazo" max-width="290">
        <v-card>
          <v-card-title class="text-h5">
            Motivo del Rechazo
          </v-card-title>

          <v-card-text>
            {{ mensajeRechazo }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="motivoRechazo = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";

export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    CardIeaAppMain
  },

  data: () => ({
    hoy: moment(new Date()).format("YYYY-MM-DD"),
    title: "Nuevo trámite",
    tramite: { text: "", value: "" },
    curso: { text: "", value: "" },
    sede: { text: "", value: "" },
    urgencia: { text: "Normal", value: "Normal" },
    select: {},
    urgencias: [
      { text: "Normal", value: "Normal" },
      { text: "Media", value: "Media" },
      { text: "Alta", value: "Alta" }
    ],
    tramites: [],
    cursos: [],
    tramitesUser: [],
    sedes: [],
    person: "",
    personRules: [v => !!v || "Campo obligatorio"],
    motivoRechazo: false,
    mensajeRechazo: "",
    tramitesEmail: [32, 39, 15, 4], // IDs of tramites that will be sent by email
    materias: "",
    tipoExamen: "",
    fechaExamen: "",
    menu: false,
    tiposExamen: [
      { text: "1er Parcial", value: "1er Parcial" },
      { text: "2do Parcial", value: "2do Parcial" },
      { text: "Recuperatorio", value: "Recuperatorio" },
      { text: "Examen Final", value: "Examen Final" }
    ]
  }),

  methods: {
    async addTramite() {
      // base de datos aceptado feedback
      let tramite = this.tramite.value;
      let sede = this.sede.value;
      let urgencia = this.urgencia.value;

      let dataSend = {
        process: tramite,
        sede: sede,
        emergency: urgencia,
        person: this.person,
        curso: this.curso.text
      };

      // Agregar campos adicionales si es trámite 36
      if (tramite === 36) {
        dataSend.materias = this.materias;
        dataSend.tipoExamen = this.tipoExamen;
        dataSend.fechaExamen = this.fechaExamen;
      }

      let url = "alumno-tramite/store";
      await this.$API
        .post({
          url: url,
          data: dataSend
        })
        .then(() => {
          this.loadTramites();
        });
    },
    async loadTramites() {
      let url = "alumno-tramites";
      await this.$API
        .get({
          url: url
        })
        .then(res => {
          this.tramitesUser = res;
        });
    },

    motivoRechazoTramite(motivo) {
      this.mensajeRechazo = motivo;
      this.motivoRechazo = true;
    },

    async loadCursos() {
      let url = "alumno/cursos";
      await this.$API
        .get({
          url: url
        })
        .then(res => {
          this.cursos = res
            .filter(curso => curso.curso_data !== null)
            .map(curso => ({
              text: curso.curso_data.nombre,
              value: curso.curso_data.IDF
            }));
        })
        .catch(err => {
          console.log(err);
        });
    },

    async tramites() {
      this.$API
        .get({
          url: "tramites",
          data: {
            curso: this.curso.text
          }
        })
        .then(res => {
          this.tramites = res;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.loadCursos();
    this.motivoRechazo = false;
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true ||
      this.$store.getters.user.excedente
    ) {
      this.$router.push({
        name: "Home"
      });
    }
    console.log(this.hoy);
    this.idTest = this.$route.params.test;

    this.$API
      .get({
        url: "sedes",
        data: {}
      })
      .then(res => {
        this.sedes = res;
      })
      .catch(err => {
        console.log(err);
      });
    this.$API
      .get({
        url: "alumno-tramites"
      })
      .then(res => {
        this.tramitesUser = res;
      });
  },
  watch: {
    curso: {
      handler() {
        this.$API
          .get({
            url: `tramites?curso=${this.curso.text}`
          })
          .then(res => {
            this.tramites = res;
          })
          .catch(err => {
            console.log(err);
          });
      },
      immediate: true
    }
  }
};
</script>
